import { useState, useCallback } from 'react';

interface BtcPriceData {
  usdPrice: number | null;
  loading: boolean;
  error: string | null;
}

export const useBtcPrice = () => {
  const [priceData, setPriceData] = useState<BtcPriceData>({
    usdPrice: null,
    loading: false,
    error: null,
  });

  const fetchBtcPrice = useCallback(async () => {
    setPriceData((prev) => ({ ...prev, loading: true, error: null }));

    try {
      const response = await fetch(
        'https://api.binance.com/api/v3/ticker/price?symbol=BTCUSDT'
      );

      if (!response.ok) {
        throw new Error('Failed to fetch Bitcoin price');
      }

      const data = await response.json();
      const usdPrice = parseFloat(data.price);

      if (typeof usdPrice === 'number' && !isNaN(usdPrice)) {
        setPriceData({
          usdPrice,
          loading: false,
          error: null,
        });
      } else {
        throw new Error('Invalid price data received');
      }
    } catch (error) {
      setPriceData({
        usdPrice: null,
        loading: false,
        error: error instanceof Error ? error.message : 'Failed to fetch price',
      });
    }
  }, []);

  const convertBtcToUsd = useCallback(
    (btcAmount: number): number | null => {
      if (!priceData.usdPrice || isNaN(btcAmount) || btcAmount <= 0) {
        return null;
      }
      return parseFloat((btcAmount * priceData.usdPrice).toFixed(2));
    },
    [priceData.usdPrice]
  );

  return {
    ...priceData,
    fetchBtcPrice,
    convertBtcToUsd,
  };
};
